import { render } from "./DetailCarpool.view.vue?vue&type=template&id=bda29e7c"
import script from "./DetailCarpool.view.vue?vue&type=script&lang=js"
export * from "./DetailCarpool.view.vue?vue&type=script&lang=js"

import "./DetailCarpool.view.vue?vue&type=style&index=0&id=bda29e7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__